import i18n from '@/i18n';

/**
 * Даты из API в подписи интерфейса. Локаль берётся из i18n, как у чисел в
 * useBytes: «8 октября» на странице должно выглядеть так же, как остальные даты.
 */
export function useDates() {
	// Пустая строка вместо исключения: битая дата с бэкенда не должна ронять рендер
	const formatDate = (raw: string | null | undefined, format: string): string => {
		if (!raw) return '';
		const parsed = Date.parse(raw);
		if (Number.isNaN(parsed)) return '';
		return i18n.global.d(new Date(parsed), format);
	};

	// Целых дней до даты, не меньше одного: «через 0 дней» читается как ошибка
	const daysUntil = (raw: string | null | undefined): number | null => {
		if (!raw) return null;
		const parsed = Date.parse(raw);
		if (Number.isNaN(parsed)) return null;
		return Math.max(1, Math.ceil((parsed - Date.now()) / 86_400_000));
	};

	return {
		formatDate,
		daysUntil
	};
}
